import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[grid-header-top-action-template]',
  standalone: false,
})
export class GridHeadeTopActionTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
